$(document).ready(function () {
    $('.pull-quote-carousel-slides').each(function () {
        $(this).slick({
            slidesToShow: 1,
            arrows: true,
            dots: false,
            fade: true,
            prevArrow: $(this).closest('.pull-quote-carousel').find('.pull-quote-carousel-arrow-prev'),
            nextArrow: $(this).closest('.pull-quote-carousel').find('.pull-quote-carousel-arrow-next'),
        });
    });
});